import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from '../../modules/nz-zorro-antd.module';
import { NgZorroIconModule } from '../../modules/nz-icon-antd.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsModule } from '../validation-errors/validation-errors.module';
import { SelectorComponent } from './selector.component';

@NgModule({
	declarations: [
		SelectorComponent
	],
	imports: [
		CommonModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		ReactiveFormsModule,
		ValidationErrorsModule
	],
	exports: [
		SelectorComponent
	]
})

export class SelectorModule { }
